import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import Home from "./pages/home/Home";
import PackagePlan from "./pages/PackagePlan";
import Login from "./pages/Login";
import { ChakraProvider } from "@chakra-ui/react";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import { AuthProvider } from "./context/authContext";
import Compare from "./pages/Compare";
import Services from "./Services";
import ForgotPassword from "./pages/ForgotPassword";
import NewPassword from "./pages/NewPassword";
import PrivateRoute from "./component/PrivateRoute";

function App() {
  return (
    <AuthProvider>
      <ChakraProvider>
        <div className="App">
          <Router>
            <Switch>
              <Route path="/" exact>
                <Home />
              </Route>
              <Route path="/services" exact>
                <Services />
              </Route>
              <Route path="/services/:selectedPackage">
                <PackagePlan />
              </Route>
              <Route path="/login" exact>
                <Login />
              </Route>
              <Route path="/register" exact>
                <Register />
              </Route>
              <PrivateRoute path="/dashboard" component={Dashboard} />

              <Route path="/compare" exact>
                <Compare />
              </Route>
              <Route path="/forgot-password" exact>
                <ForgotPassword />
              </Route>
              <Route path="/recovery" exact>
                <NewPassword />
              </Route>
            </Switch>
          </Router>
        </div>
      </ChakraProvider>
    </AuthProvider>
  );
}

export default App;
